import { SystemicMapAPI } from "../infrastructure/api/SystemicMap.api";

/**
 * A map, opened inside a call rather than in a tab: the therapist's
 * chrome-less page of it to frame, and a fresh link for the patient.
 *
 * Minting ends the map's previous link, which is what a call wants — the one
 * person who should be on the board is the one in the room.
 */
export async function openSystemicMapInMeeting(mapId: string): Promise<{
    therapistPath: string;
    patientPath: string;
}> {
    const { data: link } = await SystemicMapAPI.createShareLink(mapId);
    return {
        therapistPath: embeddedSystemicMapPath(mapId),
        patientPath: `/systemic-map/patient/${link.token}`,
    };
}

/** The therapist's map with no app chrome, for framing inside a call. */
export function embeddedSystemicMapPath(mapId: string): string {
    return `/meeting-board/systemic-map/${mapId}`;
}
